import axios from "./axios";
import Cookies from "js-cookie";

const setSession = (accessToken, isVendor = false) => {
  localStorage.setItem("accessToken", accessToken);
  Cookies.set("__afritas_token", accessToken, {
    domain: ".useafritas.com",
    secure: true,
    path: "/",
    sameSite: "Lax",
    expires: 365,
  });
  Cookies.set("__afritas_type", isVendor ? "" : "guest", {
    domain: ".useafritas.com",
    secure: true,
    path: "/",
    sameSite: "Lax",
    expires: 365,
  });
  setHeader();
};
const setHeader = () => {
  const accessToken = window.localStorage.getItem("accessToken")
    ? window.localStorage.getItem("accessToken")
    : "";
  axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
};

const setHideWallet = (isHidden) => {
  if (isHidden) {
    localStorage.setItem("hideWallet", "true");
  } else {
    localStorage.removeItem("hideWallet");
  }
};
const getHideWallet = () => window.localStorage.getItem("hideWallet") || "";

export { setSession, setHeader, setHideWallet, getHideWallet };
